import React from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';
import { PERFORMANCE_METRIC_STATUSES } from '../../../shared/constants/checkpoint-performance-report-metric-enums';
import constants from '@shared-styles/constants.module.scss';

/**
 * @typedef {object} StatusSelectProps
 * @property {boolean} [disabled]
 * @property {Object} [performanceMetric]
 * @property {number} [value]
 * @property {(status: string | number, performanceMetric: Object) => void} [handleChange]
 */

/**
 * @param {StatusSelectProps} props
 */
const StatusSelect = props => {
  const {
    performanceMetric,
    handleChange,
    disabled = false,
    value = PERFORMANCE_METRIC_STATUSES.Update.Id
  } = props;

  const options = Object.keys(PERFORMANCE_METRIC_STATUSES).map(
    key => PERFORMANCE_METRIC_STATUSES[key]
  );

  return (
    <FormControl variant='standard' style={{ minWidth: 140 }}>
      <Select
        variant='standard'
        className='status-select'
        MenuProps={{
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left'
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left'
          },
          MenuListProps: {
            style: { backgroundColor: constants.whiteColor }
          }
        }}
        inputProps={{ 'aria-label': 'Status Select' }}
        disabled={disabled}
        value={value}
        onChange={event => handleChange(event.target.value, performanceMetric)}
        disableUnderline>
        {options.map((option, i) => {
          return (
            <MenuItem
              sx={{
                color: constants.blackColor
              }}
              selected={value === option.Id}
              value={option.Id}
              key={i}>
              {option.Value}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default StatusSelect;
